import { Injectable } from "@angular/core";
import { Rate } from "../model/Rate";
import { RateSubscription } from "../model/RateSubscription";
import { IRateService } from "../IRateService";
import { Subject } from "rxjs";
import { Product, Tenor } from "shared/cubiq-model-multi-asset";

export abstract class RatePromiseService implements IRateService {
  abstract getRateEventSubject(): Subject<Array<Rate>>;
  abstract getSpotRate(productCode: string): Promise<Rate>;
  abstract getSpotRates(productCodes: Array<string>): Promise<Array<Rate>>;
  abstract getRate(
    productCode: string,
    product: Product,
    tenor: Tenor,
    valueDate: Date,
  ): Promise<Rate>;
  abstract getRates(rateSubscriptions: Array<RateSubscription>): Promise<Array<Rate>>;
  abstract pauseStream(): Promise<void>;
  abstract resumeStream(): Promise<void>;
  abstract isStreamingPaused(): Promise<boolean>;
}
